import { usePoMutation, sendAuthCode } from '@gov-nx/api';

interface UseSendAuthCodeQueryProps {
	onSuccess?: (data: Awaited<ReturnType<typeof sendAuthCode>>) => void;
}

export const useSendAuthCodeQuery = (props?: UseSendAuthCodeQueryProps) => {
	const mutation = usePoMutation({
		mutationFn: sendAuthCode,
		onSuccess: (data) => {
			props?.onSuccess?.(data);
		},
	});

	return mutation;
};
